import React from 'react';
import { Card, Button, Form, FormGroup, Container, Row, Col } from 'react-bootstrap';

const ChoiceRadio = (props) => {
    console.log("[FactualityRadio]: selected - ", props.selected)
    return (
        <div>
            <p>
                Is the modification correct?
            </p>
            <FormGroup>
                <Form.Check
                    required
                    type="radio"
                    name={"correct-modification"}
                    key={"correct-" + props.id}
                    id={"correct-" + props.id}
                    label="Yes"
                    value="correct"
                    checked={props.selected === "correct"}
                    onChange={props.handleChange}
                />
                <Form.Check
                    required
                    type="radio"
                    name={"correct-modification"}
                    key={"incorrect-" + props.id}
                    id={"incorrect-" + props.id}
                    label="No"
                    value="incorrect"
                    checked={props.selected === "incorrect"}
                    onChange={props.handleChange}
                />
                {/* <Form.Check
                    required
                    type="radio"
                    name={"correct-modification"}
                    key={"unknown-" + props.id}
                    id={"unknown-" + props.id}
                    label="N/A"
                    value="unknown"
                    checked={props.selected === "unknown"}
                    onChange={props.handleChange}
                /> */}
            </FormGroup>
        </div>
    )
}

const Question = (props) => {
    console.log("[Question]: selected -", props.selected)
    return (
        <div className='mb-20'>
            <h2>Question</h2>
            <Card>
                <Card.Body>
                    <Form onSubmit={props.onSubmit}>
                        <Container fluid>
                            <ChoiceRadio
                                handleChange={props.handleChange}
                                id={props.id}
                                selected={props.selected}
                            />
                            <Row>
                                <Col>
                                    <p>Explain your decision (if necessary):</p>
                                    <Form.Control 
                                        required name='explanation' as="textarea" rows="1"
                                        value={props.explanation} onChange={props.handleChange}
                                        style={{ marginBottom: '10px' }}  // Add margin bottom for spacing
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='text-center'>
                                        <Button variant="secondary" onClick={props.handleBack}>Back</Button>
                                    </div>
                                </Col>
                                <Col>
                                    <div className='text-center'>
                                        <Button type='submit'>Next</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    )
}

export default Question;